import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '../constants/namespaces';

export const useTranslate = (namespace = NAMESPACES.INITIAL) => {
  const { t, ready } = useTranslation(namespace, {
    useSuspense: false,
  });
  return ready ? t : (key) => key;
};
